import { atom } from "jotai";

import { locationApi } from "../services";
import { contactAddressForm } from "./contactAddressForm";
import { contactAddressDefaultPlaceAtom } from "./contactAddressVisibility";

/**
 * Switches the form between "editing an existing address" and "creating a
 * new one": populates the fields from the fetched address detail, or clears
 * them back to blank (with the modal's default place) when going back to
 * "new".
 */
export const selectExistingContactAddressAtom = atom(
  null,
  async (get, set, addressId: number | null) => {
    const fields = contactAddressForm.fields;

    set(fields.existingAddressId.atom, addressId ?? undefined);

    if (addressId == null) {
      set(fields.place.atom, get(contactAddressDefaultPlaceAtom));
      set(fields.street.atom, "");
      set(fields.extendedAddress.atom, "");
      set(fields.postOfficeBox.atom, "");
      set(fields.postalCode.atom, "");
      set(fields.city.atom, "");
      set(fields.country.atom, "CH");

      return;
    }

    const address = await locationApi.fetchAddress(addressId);

    set(fields.place.atom, address.place ?? "");
    set(fields.street.atom, address.street ?? "");
    set(fields.extendedAddress.atom, address.extendedAddress ?? "");
    set(fields.postOfficeBox.atom, address.postOfficeBox ?? "");
    set(fields.postalCode.atom, address.postalCode ?? "");
    set(fields.city.atom, address.city ?? "");
    set(fields.country.atom, address.country ?? "CH");
  },
);
